'use client'

import '@ccpgames/eve-web-core/styles.css'
import '@ccpgames/eve-web-new-eden-map/styles.css'
import '@/styles/global.css'

import { EveProvider } from '@ccpgames/eve-web-core'
import { theme } from '@/styles/theme'
import { ExperienceProvidersWrapper } from '@/components/providers'

interface Props {
  children: React.ReactNode
  locale: string
}

export function Providers({ children, locale }: Props) {
  return (
    <EveProvider theme={theme} locale={locale} defaultColorScheme="dark">
      <ExperienceProvidersWrapper locale={locale}>{children}</ExperienceProvidersWrapper>
    </EveProvider>
  )
}
